import * as _ from 'lodash';
import { FormEvent } from 'react';
import { IContact } from '@nkr/models/contact';
import { Col, ControlLabel, Form, FormControl, FormGroup, Panel, Row } from 'react-bootstrap';
import { IValidationStart } from './validation';

interface IProps {
    hasEmail: number,
    coordinatorContactId: number,
    email: string,
    dirty: boolean,
    validation: IValidationStart,
    coordinatorList: IContact[],
    onHasEmailChange: (hasEmail: number) => void,
    onCoordinatorContactChange: (coordinatorContactId: number) => void,
    onEmailChange: (email: string) => void,
    onContinue: () => void
}

const AddEditStart = (props: IProps) => {
    const handleHasEmailChange = (hasEmail: number) => {
        props.onHasEmailChange(hasEmail);
    };

    const handleCoordinatorContactChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onCoordinatorContactChange(parseInt(e.currentTarget.value));
    };

    const handleEmailChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onEmailChange(e.currentTarget.value);
    };

    const coordinatorList = _.sortBy(props.coordinatorList, item => item.fullName);

    return (
        <>
            <Row>
                <Col xs={12} lg={8} lgOffset={2}>
                    <Panel>
                        <Panel.Heading>Step 1</Panel.Heading>
                        <Panel.Body>
                            <Form horizontal>
                                <FormGroup validationState={props.dirty && props.validation.hasEmail == false ? 'error' : null}>
                                    <Col xs={12} sm={6} componentClass={ControlLabel}>Does this donor have an e-mail address?</Col>
                                    <Col xs={12} sm={6}>
                                        <label className='radio-inline'>
                                            <input
                                                type='radio'
                                                id='hasEmailYes'
                                                name='hasEmail'
                                                checked={props.hasEmail == 1}
                                                onClick={() => handleHasEmailChange(1)} /> Yes
                                        </label>
                                        <label className='radio-inline'>
                                            <input
                                                type='radio'
                                                id='hasEmailNo'
                                                name='hasEmail'
                                                checked={props.hasEmail == 0}
                                                onClick={() => handleHasEmailChange(0)} /> No
                                        </label>
                                    </Col>
                                </FormGroup>

                                {props.hasEmail == 0 && (
                                    <FormGroup validationState={props.dirty && props.validation.coordinatorContactId == false ? 'error' : null}>
                                        <Col xs={12} sm={6} componentClass={ControlLabel}>Select coordinator who will receive e-mail instead</Col>
                                        <Col xs={12} sm={6}>
                                            <FormControl
                                                componentClass='select'
                                                value={props.coordinatorContactId}
                                                onChange={handleCoordinatorContactChange}
                                            >
                                                <option value=''>- Select Coordinator -</option>
                                                {coordinatorList.map((item, index) =>
                                                    <option key={'coord-' + index} value={item.id}>{item.fullName}</option>
                                                )}
                                            </FormControl>
                                        </Col>
                                    </FormGroup>
                                )}

                                {props.hasEmail == 1 && (
                                    <FormGroup style={{ marginBottom: 0 }} validationState={props.dirty && (props.validation.email == false || props.validation.emailNotDuplicate == false) ? 'error' : null}>
                                        <Col xs={12} sm={6} componentClass={ControlLabel}>Enter donor's e-mail address</Col>
                                        <Col xs={12} sm={6}>
                                            <FormControl
                                                value={props.email}
                                                onChange={handleEmailChange} />
                                        </Col>
                                    </FormGroup>
                                )}
                            </Form>
                        </Panel.Body>
                    </Panel>
                </Col>
            </Row>

            <Row>
                <Col xs={12}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button type='button' className='btn btn-primary col-xs-12 col-lg-2' onClick={props.onContinue}>Continue</button>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default AddEditStart;